export const convertStringToNumber = (input, nullable = false) => {
  if (input === '00') return 0;
  // Remove non-numeric characters except the first dot
  const value = input.replace(/[^0-9.]/g, '');
  if (nullable && input === '') {
    return null;
  }
  // If value is empty or only contains a dot, return '0'
  if (!value || value === '.') {
    return 0;
  }

  // If the value contains more than one dot, remove extra dots
  if (value.split('.').length > 2) {
    const [integerPart, decimalPart] = value.split('.');
    return parseFloat(`${integerPart}.${decimalPart.slice(0, 2)}`); // Example: limit to two decimal places
  }

  // If the value starts with a '0' but is not a decimal number, remove the leading zero
  if (value[0] === '0' && value[1] !== '.' && value.length > 1) {
    return value.slice(1);
  }

  if (value[value.length - 1] === '.') {
    return value;
  }

  if (value.includes('.') && value[value.length - 1] === '0') {
    return value;
  }
  return parseFloat(value);
};

export const convertStringToInt = (str, nullable = false) => {
  // Remove all non-digit characters
  const digitsOnly = str.replace(/\D/g, '');

  // Handle empty string or no valid digits
  if (!digitsOnly) return nullable ? null : 0;

  // Parse to number, removing leading zeros unless the number is just '0'
  const num = parseInt(digitsOnly, 10);

  return digitsOnly === '0' ? 0 : num;
};
